"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAccess = exports.reduceGroupsToScopes = exports.OrganisationTierScopes = exports.GlobalAppScopes = exports.groupScopes = exports.CoreUserGroupScopes = exports.UserGroupScopes = exports.GlobalUserScopes = exports.UserScopes = exports.AppScopes = exports.Scopes = exports.CoreUserGroups = exports.UserGroups = void 0;
const organisations_1 = require("./organisations");
const lodash_1 = require("lodash");
var UserGroups;
(function (UserGroups) {
    UserGroups["OWNER"] = "owner";
    UserGroups["ADMIN"] = "admin";
    UserGroups["BETA"] = "beta";
})(UserGroups = exports.UserGroups || (exports.UserGroups = {}));
var CoreUserGroups;
(function (CoreUserGroups) {
    CoreUserGroups["DEVELOPER"] = "developer";
    CoreUserGroups["BETA"] = "beta";
})(CoreUserGroups = exports.CoreUserGroups || (exports.CoreUserGroups = {}));
/**
 * @deprecated Use AppScopes and UserScopes separately instead.
 */
var Scopes;
(function (Scopes) {
    // Organisation scopes
    Scopes["ORG_CREATE"] = "org:create";
    Scopes["ORG_LIST"] = "org:list";
    Scopes["ORG_READ"] = "org:read";
    Scopes["ORG_UPDATE"] = "org:update";
    Scopes["ORG_REMOVE"] = "org:remove";
    Scopes["ORG_STATS"] = "org:stats";
    // Destination scopes
    Scopes["DST_CREATE"] = "dst:create";
    Scopes["DST_LIST"] = "dst:list";
    Scopes["DST_READ"] = "dst:read";
    Scopes["DST_UPDATE"] = "dst:update";
    Scopes["DST_REMOVE"] = "dst:remove";
    Scopes["DST_STATS"] = "dst:stats";
    // Job scopes
    Scopes["JOB_CREATE"] = "job:create";
    Scopes["JOB_LIST"] = "job:list";
    Scopes["JOB_READ"] = "job:read";
    // User scopes
    Scopes["USR_CREATE"] = "usr:create";
    Scopes["USR_LIST"] = "usr:list";
    Scopes["USR_READ"] = "usr:read";
    Scopes["USR_UPDATE"] = "usr:update";
    Scopes["USR_REMOVE"] = "usr:remove";
    // Development
    /**
     * @deprecated. Use a specific scope instead.
     */
    Scopes["ALPHA"] = "dev:alpha";
    /**
     * @deprecated. Use a specific scope instead.
     */
    Scopes["BETA"] = "dev:beta";
})(Scopes = exports.Scopes || (exports.Scopes = {}));
var AppScopes;
(function (AppScopes) {
    // Organisation scopes
    AppScopes["ORG_SFTP"] = "org:sftp";
    AppScopes["ORG_STATS"] = "org:stats";
    AppScopes["DST_STATS"] = "dst:stats";
    // User management scopes
    AppScopes["USR_LIST"] = "usr:list";
    AppScopes["USR_INVITE"] = "usr:invite";
    AppScopes["USR_UPDATE"] = "usr:update";
})(AppScopes = exports.AppScopes || (exports.AppScopes = {}));
var UserScopes;
(function (UserScopes) {
    // Organisation scopes
    UserScopes["ORG_CREATE"] = "org:create";
    UserScopes["ORG_LIST"] = "org:list";
    UserScopes["ORG_READ"] = "org:read";
    UserScopes["ORG_UPDATE"] = "org:update";
    UserScopes["ORG_REMOVE"] = "org:remove";
    // Destination scopes
    UserScopes["DST_CREATE"] = "dst:create";
    UserScopes["DST_LIST"] = "dst:list";
    UserScopes["DST_LIST_ALL"] = "dst:list-all";
    UserScopes["DST_READ"] = "dst:read";
    UserScopes["DST_UPDATE"] = "dst:update";
    UserScopes["DST_REMOVE"] = "dst:remove";
    // Job scopes
    UserScopes["JOB_CREATE"] = "job:create";
    UserScopes["JOB_LIST"] = "job:list";
    UserScopes["JOB_READ"] = "job:read";
    // User scopes
    UserScopes["USR_CREATE"] = "usr:create";
    UserScopes["USR_INVITE"] = "usr:invite";
    UserScopes["USR_LIST"] = "usr:list";
    UserScopes["USR_READ"] = "usr:read";
    UserScopes["USR_UPDATE"] = "usr:update";
    UserScopes["USR_REMOVE"] = "usr:remove";
    // Development
    /**
     * @deprecated. Use a specific scope instead.
     */
    UserScopes["ALPHA"] = "dev:alpha";
    /**
     * @deprecated. Use a specific scope instead.
     */
    UserScopes["BETA"] = "dev:beta";
})(UserScopes = exports.UserScopes || (exports.UserScopes = {}));
// User Group Scopes
exports.GlobalUserScopes = [
    UserScopes.ORG_CREATE,
    UserScopes.ORG_LIST,
    UserScopes.ORG_READ,
    UserScopes.DST_LIST,
    UserScopes.DST_READ,
    UserScopes.JOB_LIST,
    UserScopes.JOB_READ
];
const AdminUserScopes = [
    UserScopes.ORG_UPDATE,
    UserScopes.DST_LIST_ALL,
    UserScopes.DST_CREATE,
    UserScopes.DST_REMOVE,
    UserScopes.DST_UPDATE,
    UserScopes.USR_LIST,
    UserScopes.USR_READ,
    UserScopes.USR_CREATE,
    UserScopes.USR_UPDATE,
    UserScopes.USR_REMOVE
];
const OwnerUserScopes = [
    ...AdminUserScopes,
    UserScopes.ORG_REMOVE
];
const BetaUserScopes = [];
exports.UserGroupScopes = {
    [UserGroups.ADMIN]: AdminUserScopes,
    [UserGroups.OWNER]: OwnerUserScopes,
    [UserGroups.BETA]: BetaUserScopes
};
exports.CoreUserGroupScopes = {
    [CoreUserGroups.BETA]: [UserScopes.USR_LIST, UserScopes.USR_CREATE, UserScopes.USR_REMOVE],
    [CoreUserGroups.DEVELOPER]: [UserScopes.USR_LIST, UserScopes.USR_CREATE, UserScopes.USR_REMOVE]
};
/**
 * @deprecated Use UserGroupScopes and OrganisationTierScopes separately instead.
 */
exports.groupScopes = {};
const TierFree = [];
const TierStarter = [
    ...TierFree,
    AppScopes.ORG_SFTP
];
const TierBasic = [
    ...TierStarter
];
const TierPro = [
    ...TierBasic
];
exports.GlobalAppScopes = [
    AppScopes.ORG_STATS,
    AppScopes.DST_STATS
];
exports.OrganisationTierScopes = {
    [organisations_1.OrganisationTier.FREE]: TierFree,
    [organisations_1.OrganisationTier.STARTER]: TierStarter,
    [organisations_1.OrganisationTier.BASIC]: TierBasic,
    [organisations_1.OrganisationTier.PRO]: TierPro,
    [organisations_1.OrganisationTier.ENTERPRISE]: []
};
const reduceGroupsToScopes = ({ user, org, userOrg, dst, userDst } = {}) => {
    let userScopes = [...exports.GlobalUserScopes];
    let appScopes = [...exports.GlobalAppScopes];
    if (user) {
        userScopes = [...userScopes, ...user.groups?.reduce((memo, cur) => {
                return [...memo, ...exports.CoreUserGroupScopes[cur]];
            }, []) || [], ...user.scopes || []];
    }
    if (userOrg) {
        userScopes = [...userScopes, ...userOrg.groups?.reduce((memo, cur) => {
                return [...memo, ...exports.UserGroupScopes[cur]];
            }, []) || [], ...userOrg.scopes || []];
    }
    if (org) {
        appScopes = [...appScopes, ...exports.OrganisationTierScopes[org.tier || organisations_1.OrganisationTier.FREE], ...org.scopes || []];
    }
    if (userDst) {
        userScopes = [...userScopes, ...userDst.groups?.reduce((memo, cur) => {
                return [...memo, ...exports.UserGroupScopes[cur]];
            }, []) || [], ...userDst.scopes || []];
    }
    if (dst) {
        appScopes = [...appScopes, ...dst.scopes || []];
    }
    return {
        appScopes: (0, lodash_1.uniq)(appScopes),
        usrScopes: (0, lodash_1.uniq)(userScopes)
    };
};
exports.reduceGroupsToScopes = reduceGroupsToScopes;
const hasAccess = ({ claims, emitErrors, requiredUserScopes, requiredAppScopes }) => {
    if (!claims) {
        if (emitErrors) {
            throw new Error(`Unauthorised`);
        }
        return false;
    }
    if (!requiredUserScopes && !requiredAppScopes) {
        return true;
    }
    // Check any user level scopes
    if (requiredUserScopes) {
        const missingScopes = requiredUserScopes.filter((requiredScope) => {
            return !claims.usrScopes?.includes(requiredScope);
        });
        if (missingScopes.length !== 0) {
            if (emitErrors) {
                throw new Error(`Forbidden. Missing required user scopes: "${missingScopes.join('", "')}"`);
            }
            return false;
        }
    }
    // Check any org level scopes
    if (requiredAppScopes) {
        const missingScopes = requiredAppScopes.filter((requiredScope) => {
            return !claims.appScopes?.includes(requiredScope);
        });
        if (missingScopes.length !== 0) {
            if (emitErrors) {
                throw new Error(`Forbidden. Missing required app scopes: "${missingScopes.join('", "')}"`);
            }
            return false;
        }
    }
    return true;
};
exports.hasAccess = hasAccess;
